import React from 'react';

export const GlobeIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        version="1.1"
        preserveAspectRatio="xMinYMin slice"
        viewBox="0 0 32 32"
        focusable="false"
        height="14"
        width="14"
    >
        <path
            d="M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm10.9 9a11.88 11.88 0 0 1 1.05 4h-5.97a30.47 30.47 0 0 0-.38-4zm-1.17-2h-4.54a16.06 16.06 0 0 0-1.77-4.5 12.03 12.03 0 0 1 6.3 4.5zm-13.71 6a27.88 27.88 0 0 1 .4-4h7.16a27.88 27.88 0 0 1 .4 4zm7.96 2a27.88 27.88 0 0 1-.4 4h-7.16a27.88 27.88 0 0 1-.4-4zM16 4c.89 0 2.24 1.8 3.12 5h-6.24c.88-3.2 2.23-5 3.12-5zm-3.42.5A16.06 16.06 0 0 0 10.81 9H6.27a12.03 12.03 0 0 1 6.31-4.5zM5.11 11h5.29a30.47 30.47 0 0 0-.38 4H4.05a11.88 11.88 0 0 1 1.05-4zm0 10a11.88 11.88 0 0 1-1.06-4h5.97a30.47 30.47 0 0 0 .38 4zm1.16 2h4.54a16.06 16.06 0 0 0 1.77 4.5 12.03 12.03 0 0 1-6.3-4.5zM16 28c-.89 0-2.24-1.8-3.12-5h6.24c-.88 3.2-2.23 5-3.12 5zm3.42-.5a16.06 16.06 0 0 0 1.77-4.5h4.54a12.03 12.03 0 0 1-6.31 4.5zm7.47-6.5h-5.3a30.47 30.47 0 0 0 .39-4h5.97a11.88 11.88 0 0 1-1.06 4z"
            fill="rgba(0, 0, 0, 0.6)"
        />
        <path fill="none" d="M0 0h32v32H0z" />
    </svg>
);
